import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProceduresContent from '../components/ProceduresContent';

const Procedures = () => {
  return (
    <div className="procedures-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <ProceduresContent />
      <Footer />
    </div>
  );
};

export default Procedures;